import React from 'react';
import { motion } from 'framer-motion';
export function ProductIntro() {
  return <section className="w-full bg-navy-mid px-5 py-10 sm:py-16" data-id="element-152" data-mp="22lezoe7p17k6">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.3
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="mx-auto flex max-w-2xl flex-col items-center text-center" data-id="element-153" data-mp="22mq7cp49ezgk">
        <span className="mb-5 inline-block rounded-full border border-gold/60 bg-gold/10 px-4 py-1.5 text-[11px] font-semibold uppercase tracking-wider text-gold" data-id="element-154" data-mp="2gf6272n0br6e">
          What&apos;s inside the system
        </span>
        <h2 className="font-display text-3xl font-bold leading-tight text-white sm:text-5xl" data-id="element-155" data-mp="2bltq1rzilcuj">
          Lessons, Projects, Visual Resources, Assessment and Planning—Connected in One System.
        </h2>
        <p className="mt-5 text-base font-medium text-gold sm:text-lg" data-id="element-156" data-mp="3424hvy3ayv39">
          THE COMPLETE ART YEAR™ — a complete Visual Arts teaching system created for Elementary,
          Middle School and High School Art teachers.
        </p>
        <div className="mx-auto mt-5 h-px w-16 bg-gold/60" data-id="element-157" data-mp="phwwdvgsasbt" />
        <p className="mt-5 text-sm leading-relaxed text-white/75 sm:text-base" data-id="element-158" data-mp="1458ao54coqfm">
          Inside you&apos;ll find 6 core teaching volumes covering the foundations of Visual Arts,
          drawing, color, materials, design, art history and creative projects—plus 5 professional
          teacher bonuses for assessment, yearly planning, quick activities, classroom visuals and
          student portfolios. Everything is organized to work together, so you&apos;re not left
          trying to connect a collection of unrelated files.
        </p>
      </motion.div>
    </section>;
}